export default __webpack_public_path__ + "/dist/images/cuisine-icon.svg";